import { createContext, useContext } from "react";

export type UploadContextValue = {
  upload: (file: File, onProgress: (pct: number) => void) => Promise<{ id: string; title: string }>;
  fileName: (id: string) => string | undefined;
};

/** Supplied by QuestionnairePage so the pure form can upload without knowing about the API. */
export const UploadContext = createContext<UploadContextValue | null>(null);

export function useUploadContext(): UploadContextValue | null {
  return useContext(UploadContext);
}
